<template>
  <card :title="$t('dashboard')">
    <h1 class="greeting">
      <span class="today">&nbsp;{{ $t("today_is") }} {{ todayWeekday }}, {{ todayFull }}</span>
    </h1>
    <div class="clock-widget"></div>
  </card>
</template>

<script>
export default {
  name: "Dashboard",
  middleware: "auth",
  data() {
    return {
      todayWeekday: "",
      todayFull: "",
    };
  },
  mounted() {
    this.updateTodayStrings();
  },
  methods: {
    async updateTodayStrings() {
      try {
        const generalSettings = this.$store.getters["settings/generalSettings"] || [];
        if (!generalSettings.length) {
          await this.$store.dispatch("settings/getSettingsForGeneralUsage");
        }
      } catch (error) {
        // Ignore settings errors and fall back to default locale.
      }

      const locale = this.$store.getters["settings/getLanguage"] || "en-US";
      const now = new Date();
      this.todayWeekday = now.toLocaleDateString(locale, { weekday: "long" });
      this.todayFull = now.toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" });
    },
  },
};
</script>
<style scoped>
.hero {
  text-align: center;
  border-radius: 16px;
  padding-top: 72px;
  padding-bottom: 48px;
}
.greeting {
  margin: 0 0 6px 0;
  font-size: 24px;
}
.hi {
  color: #1a8f3d;
  font-weight: 700;
  margin-right: 4px;
}
.today {
  font-weight: 700;
}
.subtitle {
  color: #808080;
  font-size: 14px;
}
</style>
